export default [
//     //  广点通  兔年尊享包19.99 加了授权代理图
//     {
//         path: '/rabbitExclusive-g',
//         name: 'rabbitExclusive-g',
//         meta: {
//             title: '兔年尊享包',
//         },
//         component: () => import('@/view/guangdiantong/rabbitExclusiveSigning-g')
//     },
//     //  广点通  兔年畅享包 19.99 加了授权代理图
//     {
//         path: '/vipMonthMonthReceiveRedEnvelope-g',
//         name: 'vipMonthMonthReceiveRedEnvelope-g',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/guangdiantong/vipMonthMonthReceiveRedEnvelope-g')
//     },
//     //  广点通  会员月月领-原色19.99 加了授权代理图
//     {
//         path: '/vipMonthMonthReceive-g',
//         name: 'vipMonthMonthReceive-g',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/guangdiantong/vipMonthMonthReceive-g')
//     },
//     //  广点通  会员月月领-紫色19.99 加了授权代理图
//     {
//         path: '/vipMonthMonthReceivePurple-g',
//         name: 'vipMonthMonthReceivePurple-g',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/guangdiantong/vipMonthMonthReceivePurple-g')
//     },
//     //  广点通  会员月月领-新19.99 加了授权代理图
//     {
//         path: '/vipMonthMonthReceiveNew-g',
//         name: 'vipMonthMonthReceiveNew-g',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/guangdiantong/vipMonthMonthReceiveNew-g')
//     },
//     //  广点通  会员月月领-新19.99 加了授权代理图
//     {
//         path: '/vipMonthMonthReceiveNew02-g',
//         name: 'vipMonthMonthReceiveNew02-g',
//         meta: {
//             title: '会员月月领',
//         },
//         component: () => import('@/view/guangdiantong/vipMonthMonthReceiveNew02-g')
//     },
    //  广点通  出行生活天天享
    // {
    //     path: '/travelVipMonthMonthReceive-g',
    //     name: 'travelVipMonthMonthReceive-g',
    //     meta: {
    //         title: '出行生活天天享',
    //     },
    //     component: () => import('@/view/guangdiantong/travelVipMonthMonthReceive-g')
    // },
//     //  广点通  生活缴费月月领
//     {
//         path: '/lifeFeeVipMonthMonthReceive-g',
//         name: 'lifeFeeVipMonthMonthReceive-g',
//         meta: {
//             title: '生活缴费月月领',
//         },
//         component: () => import('@/view/guangdiantong/lifeFeeVipMonthMonthReceive-g')
//     },
//     {
//         path: '/lifeFeeVipMonthMonthReceiveBack-g',
//         name: 'lifeFeeVipMonthMonthReceiveBack-g',
//         meta: {
//             title: '生活缴费月月领',
//         },
//         component: () => import('@/view/guangdiantong/lifeFeeVipMonthMonthReceiveBack-g')
//     },
//     // 车惠主
//     {
//         path: '/vehicleFavourHost-g',
//         name: 'vehicleFavourHost-g',
//         meta: {
//             title: '车主惠',
//         },
//         component: () => import('@/view/guangdiantong/vehicleFavourHost-g')
//     },
//     // 广点通，兔年尊享包v 加了授权代理图
//     {
//         path: '/rabbitYearExclusiveEnjoyV-g',
//         name: 'rabbitYearExclusiveEnjoyV-g',
//         meta: {
//             title: '兔年尊享包V',
//         },
//         component: () => import('@/view/guangdiantong/rabbitYearExclusiveEnjoyV-g')
//     },
//     // 广点通，兔年尊享包v 加了授权代理图 公司是四川三良互动信息技术服务有限公司
//     {
//         path: '/rabbitYearExclusiveEnjoyScV-g',
//         name: 'rabbitYearExclusiveEnjoyScV-g',
//         meta: {
//             title: '兔年尊享包V',
//         },
//         component: () => import('@/view/guangdiantong/rabbitYearExclusiveEnjoyScV-g')
//     },
//     // 广点通，兔年尊享包v 公司是成都赤金网络科技有限公司
//     {
//         path: '/rabbitYearExclusiveEnjoyCdV-g',
//         name: 'rabbitYearExclusiveEnjoyCdV-g',
//         meta: {
//             title: '兔年尊享包V',
//         },
//         component: () => import('@/view/guangdiantong/rabbitYearExclusiveEnjoyCdV-g')
//     },
//     // 广点通，兔年尊享包z 加了授权代理图
//     {
//         path: '/rabbitYearExclusiveEnjoyZ-g',
//         name: 'rabbitYearExclusiveEnjoyZ-g',
//         meta: {
//             title: '兔年尊享包z',
//         },
//         component: () => import('@/view/guangdiantong/rabbitYearExclusiveEnjoyZ-g')
//     },
//     // 广点通，兔年尊享包v 红包版 加了授权代理图
//     {
//         path: '/rabbitYearExclusiveEnjoyVRedEnvelope-g',
//         name: 'rabbitYearExclusiveEnjoyVRedEnvelope-g',
//         meta: {
//             title: '兔年尊享包V',
//         },
//         component: () => import('@/view/guangdiantong/rabbitYearExclusiveEnjoyVRedEnvelope-g')
//     },
//     // 巨擎 兔年尊享包+ 先签约后支付 加了授权代理图
//     {
//         path: '/rabbitExclusiveAdd-g',
//         name: 'rabbitExclusiveAdd-g',
//         meta: {
//             title: '兔年尊享包z',
//         },
//         component: () => import('@/view/guangdiantong/rabbitExclusiveAdd-g')
//     },
//     // 巨擎 新产品兔年尊享包+ 返回流量
//     {
//         path: '/rabbitExclusiveAddBack-g',
//         name: 'rabbitExclusiveAddBack-g',
//         meta: {
//             title: '兔年尊享包z',
//         },
//         component: () => import('@/view/guangdiantong/rabbitExclusiveAddBack-g')
//     },
//     // 巨擎 新产品生活缴费月月领+ 返回流量
//     {
//         path: '/lifeFeeVipMonthMonthReceiveAdd-g',
//         name: 'lifeFeeVipMonthMonthReceiveAdd-g',
//         meta: {
//             title: '生活缴费月月领z',
//         },
//         component: () => import('@/view/guangdiantong/lifeFeeVipMonthMonthReceiveAdd-g')
//     },
//     // 巨擎 新产品生活缴费月月领+ 返回流量
//     {
//         path: '/lifeFeeVipMonthMonthReceiveAddBack-g',
//         name: 'lifeFeeVipMonthMonthReceiveAddBack-g',
//         meta: {
//             title: '生活缴费月月领z',
//         },
//         component: () => import('@/view/guangdiantong/lifeFeeVipMonthMonthReceiveAddBack-g')
//     },
    // 龙年尊享包 投放版
    // {
    //     path: '/dragonYearExclusiveEnjoy-g',
    //     name: 'dragonYearExclusiveEnjoy-g',
    //     meta: {
    //         title: '龙年尊享包',
    //     },
    //     component: () => import('@/view/guangdiantong/dragonYearExclusiveEnjoy-g')
    // },
    // 龙年尊享包 工商版
    {
        path: '/dragonYearExclusiveEnjoyFormal-g',
        name: 'dragonYearExclusiveEnjoyFormal-g',
        meta: {
            title: '龙年尊享包',
        },
        component: () => import('@/view/guangdiantong/dragonYearExclusiveEnjoyFormal-g')
    },
    {
        path: '/gdf-g',
        name: 'gdf-g',
        meta: {
            title: '高德打车权益包',
        },
        component: () => import('@/view/guangdiantong/gd-g')
    },
    
    // 龙年尊享包 联合产品 支付宝
    // {
    //     path: '/dragonYearExclusiveJointProductFormal-g',
    //     name: 'dragonYearExclusiveJointProductFormal-g',
    //     meta: {
    //         title: '咪咕生活娱乐包',
    //     },
    //     component: () => import('@/view/guangdiantong/dragonYearExclusiveJointProductFormal-g')
    // },
    // 龙年尊享包 分流版本
    // {
    //     path: '/dragonYearExclusiveEnjoyF-g',
    //     name: 'dragonYearExclusiveEnjoyF-g',
    //     meta: {
    //         title: '龙年尊享包',
    //     },
    //     component: () => import('@/view/guangdiantong/dragonYearExclusiveEnjoyF-g')
    // },
    // {
    //     path: '/dragonYearExclusiveEnjoyPlus-g',
    //     name: 'dragonYearExclusiveEnjoyPlus-g',
    //     meta: {
    //         title: '龙年话费尊享包plus ',
    //     },
    //     component: () => import('@/view/guangdiantong/dragonYearExclusiveEnjoyPlus-g')
    // },
]
